import { Drawer } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 72px calc(100% - 72px - 92px) 92px;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 24px 24px 0;
  border-bottom: 1px solid ${COLORS.systemDark100};
  display: flex;
  justify-content: space-between;
`;

export const Body = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: auto;
`;

export const Actions = styled.div`
  border-top: 1px solid ${COLORS.systemDark100};
  padding-inline: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Fields = styled.div`
  display: grid;
  gap: 24px;
`;
